import { TabItem } from '@Common/Controls';
import '@Common/Core/DOMRect.polyfill';

const nextTabPeek = 10;

export class TabFocusAssistant {
    private shift = 0;

    constructor(private readonly header: JQuery) {}

    private ensureVisibility(tab: TabItem): void {
        const padding = this.header.find('.drop-down-tabs').width() ?? 0;
        const viewPort = this.header.parent().width() - padding;
        const { left, width, right } = this.calcTabRect(tab);
        const shift = viewPort > width ? viewPort - right - nextTabPeek : -left;
        this.setShiftTransform(Math.min(0, shift));
    }

    private calcTabRect(tab: TabItem): DOMRect {
        const width = tab.li.outerWidth(true);
        const { left } = tab.li.position();
        return new DOMRect(left, 0, width, 0);
    }

    public get isActive(): boolean {
        return this.shift !== 0;
    }

    public ensureTabVisibility(tab: TabItem): void {
        this.ensureVisibility(tab);
    }

    private setShiftTransform(shift: number): void {
        this.shift = shift;
        this.header.css('margin-left', `${this.shift}px`);
    }

    public stopAnimation(): void {
        this.header.toggleClass('stop-animation', true);
    }

    public resumeAnimation(): void {
        this.header.toggleClass('stop-animation', false);
    }
}
